import { Component, Input } from '@angular/core';
import { HtmlBase, PropertyData } from '../../../../models';
import { ToastService } from '../../../../toast/toast.service';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})

export class EmailComponent extends BaseAddOnComponent {
  @Input('input') input: PropertyData;

  constructor(private toastservice: ToastService) { super(); }

  navig(button: HtmlBase, mail: string): void {
    const regex: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    const validation: boolean = regex.test(mail);
    if (validation) {
      window.location.href = `mailto:${mail}`;
      button.OnClick = `mailto:${mail}`;
    } else this.toastservice.showWarningToast('l\'adresse mail n\'est pas valide');
  }
}
